<template>
  <div class="md:py-16 py-10 md:px-0 px-4">
    <div class="container-1240">
        <h2 class="heading-2-small mb-3">{{$t('pack_avm.title')}}</h2>
        <p class="md:mb-8 mb-5">{{$t('pack_avm.subtitle')}}</p>
        <ul class="list-disc">
            <li>{{$t('pack_avm.list_1')}}</li>
            <li>{{$t('pack_avm.list_2')}}</li>
            <li>{{$t('pack_avm.list_3')}}</li>
        </ul>
        <div class="md:flex hidden gap-3 mt-8 pack-container">
          <div v-for="(image, index) in getPackImages" :key="index" :class="`item${index + 1} rounded-xlg`">
            <img :src="image.src" :alt="image.alt" class="rounded-xlg h-[300px]">
          </div>
        </div>
        <app-horizontal-carousel class="md:hidden ml-0 mt-5 carousel-container">
          <div v-for="(image, index) in getPackImages" :key="index" class="w-64 mr-3 rounded-xlg h-[220px]">
            <v-img :src="image.src" :alt="image.alt" class="rounded-xlg h-full"/>
          </div>
        </app-horizontal-carousel>
    </div>
  </div>
</template>

<script>
  export default {
  data() {
    return {
      packImages: {
        thailand: [
          { src: '/img/guia-viaje-tailandia.webp', alt: 'Guía de Ahora Vuelvo Mamá de viaje a Tailandia' },
          { src: '/img/camara-ahora-vuelvo-mama.webp', alt: 'Cámara diseñada con el logo de Ahora Vuelvo Mamá' },
          { src: '/img/regalo-tote-bag-tailandia.webp', alt: 'Tote bag de regalo de Ahora Vuelvo Mamá para Tailandia' }
        ],
        bali: [
          { src: '/img/guia-viaje-bali.webp', alt: 'Guía de viaje Bali' },
          { src: '/img/camara-ahora-vuelvo-mama.webp', alt: 'Cámara diseñada con el logo de Ahora Vuelvo Mamá' },
          { src: '/img/regalo-tote-bag-tailandia.webp', alt: 'Tote bag de regalo de Ahora Vuelvo Mamá para Tailandia' },
        ]
      }
    };
  },
  computed: {
    getPackImages() {
      return this.destination === '/tailandia' ? this.packImages.thailand : this.packImages.bali;
    }
  },
  created() {
    this.destination = this.$route.path;
  },

  }
</script>

<style lang="scss" scoped>
  @import "../../sass/variables";
  .pack-container {
    width: 100%;
    height: 300px;
  }
  .carousel-container {
    width: 100%;
    height: 220px;
  }
</style>
